import { displayMessage } from "../../helpers/messages";
import dayjs from 'dayjs';

export default [
    {
        field: 'id',
        headerName: 'Código',
        width: 100

    },
    {
        field: 'title',
        headerName: displayMessage('NOTIFICATIONS_TITLE'),
        valueGetter: (params) => params?.row.title || '',
        width: 220
    },
    {
        field: 'description',
        headerName: displayMessage('NOTIFICATIONS_DESCRIPTION'),
        width: 220,
        valueGetter: (params) => params?.row.description || ''
    },
    {
        field: 'user_id',
        headerName: displayMessage('USER'),
        flex: 1,
        valueGetter: (params) => params?.row?.Recipient?.full_name || '-'
    },
    {
        field: 'created_by',
        headerName: displayMessage('CREATOR'),
        flex: 1,
        valueGetter: (params) => params?.row?.Creator?.full_name || '-'
    },
    {
        field: 'createdAt',
        headerName: displayMessage('CREATION_DATE'),
        valueFormatter: (params) => params.value ? dayjs(params.value)?.format('DD/MM/YYYY') : "N/I",
        width: 220
    },
]